import React from 'react'
import './About.css'

const values = [
  { icon: '🔁', title: 'Automation First', desc: 'Every manual step is a future incident. We automate ruthlessly — from testing to deployment to incident response.' },
  { icon: '🔒', title: 'Security by Design', desc: 'RBAC, secrets management, image scanning, and policy-as-code are built in from day one, not bolted on later.' },
  { icon: '📈', title: 'Observability Native', desc: 'We instrument everything — metrics, logs, and traces — so your team can debug in production without guesswork.' },
  { icon: '🤝', title: 'Platform Thinking', desc: 'We build internal developer platforms that multiply your engineering team\'s velocity without sacrificing reliability.' },
]

const stack = [
  { name: 'Kubernetes', color: '#326ce5' },
  { name: 'Terraform', color: '#7b42bc' },
  { name: 'ArgoCD', color: '#ef7b4d' },
  { name: 'GitHub Actions', color: '#2088ff' },
  { name: 'Prometheus', color: '#e6522c' },
  { name: 'Grafana', color: '#f46800' },
  { name: 'Helm', color: '#0f1689' },
  { name: 'Docker', color: '#2496ed' },
  { name: 'AWS EKS', color: '#ff9900' },
  { name: 'Azure AKS', color: '#0078d4' },
  { name: 'GKE', color: '#4285f4' },
  { name: 'Jenkins', color: '#d33833' },
]

export default function About() {
  return (
    <main style={{ paddingTop: '80px' }}>
      {/* ── Hero ─────────────────────────────────── */}
      <section className="section about-hero">
        <div className="container about-hero__inner">
          <div>
            <span className="badge">About Us</span>
            <h1>IT Delivery for the <span className="text-accent">Cloud-Native Era</span></h1>
            <p>GT Expression is an IT delivery specialist focused on building the pipelines, platforms, and processes that let engineering teams ship software confidently — faster, safer, and at scale.</p>
            <p>We operate at the intersection of CI/CD, container orchestration, and cloud infrastructure — helping organisations modernise their delivery capability on AWS, Azure, and Google Cloud.</p>
          </div>
          <div className="about-hero__visual">
            <div className="about-terminal">
              <div className="about-terminal__bar">
                <span /><span /><span />
                <p>gt-expression ~ terminal</p>
              </div>
              <div className="about-terminal__body">
                <p><span className="t-dim">$</span> kubectl get nodes</p>
                <p className="t-dim">NAME              STATUS   ROLES    AGE</p>
                <p><span className="t-green">node-1</span>  Ready    control-plane  42d</p>
                <p><span className="t-green">node-2</span>  Ready    &lt;none&gt;         42d</p>
                <p><span className="t-green">node-3</span>  Ready    &lt;none&gt;         42d</p>
                <br/>
                <p><span className="t-dim">$</span> helm upgrade gt-app ./chart --atomic</p>
                <p className="t-accent">Release "gt-app" has been upgraded. ✓</p>
                <br/>
                <p><span className="t-dim">$</span> <span className="t-cursor">_</span></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Values ───────────────────────────────── */}
      <section className="section section--alt">
        <div className="container">
          <div className="about-heading">
            <span className="badge">Our Values</span>
            <h2>How We Think About Delivery</h2>
          </div>
          <div className="about-values">
            {values.map(v => (
              <div key={v.title} className="about-value-card">
                <span className="about-value-card__icon">{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Tech stack ───────────────────────────── */}
      <section className="section">
        <div className="container">
          <div className="about-heading">
            <span className="badge">Tech Stack</span>
            <h2>The Tools We Master</h2>
            <p>We work with the leading open-source and cloud-native tools across the entire DevOps toolchain.</p>
          </div>
          <div className="about-stack">
            {stack.map(t => (
              <div key={t.name} className="about-stack__tag" style={{ borderColor: `${t.color}44`, color: t.color }}>
                {t.name}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}
